// Theo finiva-admin auth/lib/account-label.ts. Sửa: admin không có tập đoàn / công ty – nhãn là vai trò chính (+ số vai trò khác)
import type { CurrentUser } from '../types'

const BASE_ROLE = 'base'

/** Dòng mô tả tài khoản dưới tên người dùng: "Vận hành", "Vận hành +1", hoặc "Chưa gán vai trò" */
export function accountLabel(user: CurrentUser | null | undefined): string {
  const roles = (user?.roles ?? []).filter((r) => r.role !== BASE_ROLE)
  const [primary, ...others] = roles
  if (!primary) return 'Chưa gán vai trò'
  return others.length ? `${primary.displayName} +${others.length}` : primary.displayName
}
